<template>
    <div class="image-upload" :class="[{ dropover: dragging }, { preview: src }]">
        <input
            ref="fileUploadInput"
            type="file"
            accept="image/*"
            :multiple="multiple"
            @change="handleFileChange"
            @dragenter="dragging = true"
            @dragleave="dragging = false"
        />
        <div v-show="!src" class="dropzone">
            <div class="icon-container">
                <FeatherIcon name="upload" />
            </div>
            <div v-if="!minimal" class="text-container">
                <div class="copy-m bold">{{ $t('image_upload.headline') }}</div>
                <div class="copy-s">{{ $t('image_upload.description') }}</div>
            </div>
            <div v-else>
                <div class="copy-m">{{ $t('image_upload.alt_headline') }}</div>
            </div>
        </div>
        <div v-show="src" class="dropzone-preview">
            <img :src="src" alt="image upload" />
            <Button
                v-if="!hideDelete"
                class="remove-image"
                icon="trash-2"
                type="white"
                :value="$t('general.remove')"
                @click="removeImage"
            />
        </div>
        <Button v-if="false" value="Accept" type="primary" :disabled="!src" @click="handleAcceptImage" />
    </div>
</template>

<script>
import Button from '@/components/Button'
import FeatherIcon from '@/components/FeatherIcon'

export default {
    name: 'ImageUpload',
    components: { Button, FeatherIcon },
    props: {
        minimal: {
            type: Boolean,
            default: false,
        },
        imageSrc: {
            type: String,
            required: false,
        },
        autoClear: {
            type: Boolean,
            default: false,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        hideDelete: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            reader: new FileReader(),
            src: this.imageSrc,
            dragging: false,
        }
    },
    methods: {
        async toBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result)
                reader.onerror = (error) => reject(error)
            })
        },
        async handleFileChange() {
            let base64Files = []
            let files = this.$refs.fileUploadInput.files

            if (files.length < 1) {
                return
            }

            // multiple file upload
            if (files.length === 1) {
                let base64File = await this.toBase64(files[0])
                if (!this.autoClear) {
                    this.src = base64File
                }
                base64Files.push(base64File)
            } else {
                for (let file of files) {
                    base64Files.push(await this.toBase64(file))
                }
            }

            // return base64File instead of array
            if (base64Files.length === 1) {
                base64Files = base64Files[0]
            }
            this.$emit('image', base64Files)
        },
        handleAcceptImage() {},
        removeImage() {
            //this.reader = new FileReader();
            //this.src = ''
            this.$emit('remove')
        },
    },
}
</script>

<style lang="sass" scoped>
.image-upload
    position: relative
    min-width: 312px
    max-width: 900px
    min-height: 200px
    max-height: 900px
    display: grid
    place-items: center
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='12' ry='12' stroke='%23333' stroke-width='1' stroke-dasharray='5%2c5' stroke-dashoffset='0' stroke-linecap='round'/%3e%3c/svg%3e")
    border:
        radius: 12px
    +transition(100ms)

    &:hover, &.dropover
        box-shadow: 0 0 0 2px $primary-1
        background-image: none


    &.preview
        background-image: none

    input
        position: absolute
        cursor: pointer
        top: 0
        right: 0
        bottom: 0
        left: 0
        width: 100%
        height: 100%
        opacity: 0
        z-index: 4


    .dropzone-preview
        width: 100%
        padding: $m
        box-sizing: border-box
        position: relative

        img
            width: 100%
            height: 100%
            object-fit: cover
            border:
                radius: 8px

        .button.remove-image
            position: absolute
            left: $xs
            bottom: $xs
            right: $xs
            transform: scale(0.95)
            opacity: 0
            z-index: 100

    &:hover
        .dropzone-preview .button.remove-image
            transform: scale(1)
            opacity: 1

    .dropzone
        display: grid
        place-items: center

        .icon-container
            margin-bottom: $m

            .feather-icon
                width: 36px
                height: 36px

                &::v-deep
                    svg
                        stroke-width: 1.5px
                        stroke: $neutral-3


        .text-container
            text-align: center

            .copy-m
                color: $neutral-black

            .copy-s
                margin-top: $xs
</style>
